import { useMemo } from 'react';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollReveal from '@/components/base/ScrollReveal';
import { currentDayNumber, rotateByDay } from '@/utils/dailyDisplay';
import type { Article } from '@/utils/content';

/** How many articles are shown in the list at a time. */
const ARTICLES_PER_DAY = 6;

export default function CategoryArticles({ articles }: { articles: Article[] }) {
  const visibleArticles = useMemo(() => {
    const sorted = [...articles].sort((a, b) => {
      if (a.updatedDate < b.updatedDate) return 1;
      if (a.updatedDate > b.updatedDate) return -1;
      return 0;
    });
    return rotateByDay(sorted, ARTICLES_PER_DAY, currentDayNumber());
  }, [articles]);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-10">
      {visibleArticles.length > 0 && (
        <>
          <p className="mb-6 flex flex-wrap items-center gap-2 text-sm font-semibold text-foreground-800">
            <span className="h-px w-8 bg-primary-500" />
            บทความแนะนำวันนี้
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
              <i className="ri-refresh-line text-xs" />
              สลับชุดบทความทุกวัน
            </span>
          </p>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {visibleArticles.map((article, index) => (
              <ScrollReveal key={article.slug} delay={(index % 3) * 80} className="h-full">
                <ArticleCard article={article} />
              </ScrollReveal>
            ))}
          </div>
        </>
      )}

      {visibleArticles.length === 0 && (
        <p className="rounded-xl border border-background-200 bg-background-100/60 p-8 text-center text-sm text-foreground-600">
          ยังไม่มีบทความในหมวดนี้
        </p>
      )}
    </section>
  );
}